"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledVerticalNavItem = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _VerticalNavItemMixin = require("../../mixins/components/VerticalNavItemMixin");
var StyledVerticalNavItem = /*#__PURE__*/_styledComponents.default.li.withConfig({
  displayName: "StyledVerticalNavItem",
  componentId: "c11n-8-107-0__sc-1eg5s5q-0"
})(["", ""], _VerticalNavItemMixin.VerticalNavItemMixin);
exports.StyledVerticalNavItem = StyledVerticalNavItem;